jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

updateImagesForDevice();
  
});

// Changing the logo on mobbile
function updateImagesForDevice() {
  const isMobile = window.matchMedia("(max-width: 1024px)").matches;
  const images = document.querySelectorAll('.header__mobile-logo');

  images.forEach(img => {
    if (isMobile) {
      img.src = 'https://cdn.shopify.com/s/files/1/0846/7873/8195/files/ROMEO_Logo_Final.png?v=1743799980&width=360';
      img.srcset = 'https://cdn.shopify.com/s/files/1/0846/7873/8195/files/ROMEO_Logo_Final.png?v=1743799980&width=360 2x';
    } else {
      img.src = 'https://mensexgear.com/cdn/shop/files/ROMEO_Logo_Round_White_Trns-06.png?v=1743802436&width=300';
      img.srcset = 'https://mensexgear.com/cdn/shop/files/ROMEO_Logo_Round_White_Trns-06.png?v=1743802436&width=300 2x';
    }
  });
}

// Run on window resize
window.addEventListener('resize', updateImagesForDevice);






